import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import UCLogo from "@/components/site/UCLogo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user !== false) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border border-black/20 px-4 py-3 text-concrete-900 placeholder:text-concrete-400 focus:outline-none focus:border-concrete-900 transition-colors";

  return (
    <div className="min-h-screen bg-concrete-50 grain flex items-center justify-center px-5">
      <div className="relative z-10 w-full max-w-md">
        <a href="/" className="inline-flex items-center gap-2 overline text-concrete-500 hover:text-concrete-900 mb-8 transition-colors">
          <ArrowLeft className="h-3.5 w-3.5" /> Back to site
        </a>
        <div className="bg-white border border-black/10 p-8 sm:p-10">
          <div className="flex items-center gap-3 mb-8">
            <UCLogo className="h-11 w-11 text-concrete-900" />
            <div>
              <p className="font-display font-extrabold tracking-tight text-concrete-900">OWNER LOGIN</p>
              <p className="overline text-concrete-500">Upscale Concrete Services</p>
            </div>
          </div>

          <form onSubmit={submit} data-testid="admin-login-form" className="space-y-5">
            <div>
              <label className="overline text-concrete-500">Email</label>
              <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={`mt-2 ${inputCls}`} placeholder="you@upscaleconcreteservices.com" />
            </div>
            <div>
              <label className="overline text-concrete-500">Password</label>
              <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={`mt-2 ${inputCls}`} placeholder="••••••••" />
            </div>
            {error && <p data-testid="login-error" className="text-sm text-destructive">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full flex items-center justify-center gap-2 bg-concrete-900 text-white px-6 py-3.5 text-sm font-semibold uppercase tracking-wide border border-concrete-900 hover:bg-white hover:text-concrete-900 transition-colors disabled:opacity-60"
            >
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <><Lock className="h-4 w-4" /> Sign in</>}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
